<template>
  <div id="app">
    <page-header />
    <router-view />
    <page-footer />
    <dialog-host />
  </div>
</template>

<script>
import PageHeader from "@/components/page/PageHeader.vue";
import PageFooter from "@/components/page/PageFooter.vue";
import DialogHost from "@/components/common/DialogHost.vue";

export default {
  components: {
    PageHeader,
    PageFooter,
    DialogHost,
  },  
};
</script>
